
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import CONSTANTS from '../util/constants';
import { useDispatch, useSelector } from 'react-redux';
import ModalComponent from './ModalComponent';
import * as XLSX from 'xlsx';
import { DataInput } from './DataComponent';
import Encrypt from './../util/encrypt';
import { exportFile } from '../util/exportFile';

const DoorsComp = () => {

    const gridRef = useRef();
    const dispatch = useDispatch();
    const rowDataDoor = useSelector((state) => state.doors.getDoorForMove);
    const rowDataDoorLogTemp = useSelector((state) => state.doors.getDoorLogs);
    const divisionSelectedTemp = useSelector((state) => state.division.divisionSelected);

    const [modalShow, isModalShow] = useState(false);
    const [isShowLog, setIsShowLogClicked] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [cellData, setCellClickData] = useState(null);
    const [dataForLogs, setDataForLogs] = useState({});
    const [loginResponse, setLoginResponse] = useState(null);

    useEffect(() => {

        let localstorageLR = localStorage.getItem("L_R");
        if (localstorageLR) {
            let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
            let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';
            setLoginResponse(loginResponse);
        }

        dispatch({
            type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL
        })

    }, []);

    useEffect(() => {

        setColumnDefs([
            {
                label: 'Division', key: 'divisionName', headerName: 'Division', field: 'divisionName', filter: true, resizable: true, flex: 1, cellRenderer: cellBlankDivisionStyle, valueGetter: params => {
                }
            },
            { label: 'Door Type', key: 'doorType', headerName: 'Door Type', field: 'doorType', filter: true, resizable: true, flex: 1, cellRenderer: cellBlankDoorTypeStyle },
            { label: 'Number', key: 'number', headerName: 'Number', field: 'number', filter: true, resizable: true, flex: 1 },
            { label: 'Current Occupancy', key: 'currentOccupancy', headerName: 'Current Occupancy', field: 'currentOccupancy', filter: true, resizable: true, flex: 1, cellRenderer: cellBlankOccupantStyle },
            {
                field:
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                        'Update Door' : '',
                filter: true, resizable: true, flex: 1, cellRenderer: cellImageRender
            },
            { field: 'Logs', filter: true, resizable: true, flex: 1, cellRenderer: cellLogStyle, cellClass: "border-radius-md  text-center me-4 d-flex align-items-center justify-content-center" }
        ])
    }, [loginResponse])

    useEffect(() => {

        if (rowDataDoor && rowDataDoor.length > 0) {
            let filterData = rowDataDoor?.filter((item) => {
                return (divisionSelectedTemp?.value == item.division_id)
            })
            setRowData(filterData);
        }

    }, [rowDataDoor]);


    const formatAMPM = (date) => {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes;
        return strTime;
    }

    const [columnDefsLog] = useState([
        {
            headerName: 'Date', field: 'createdAt', filter: true, resizable: true, flex: 1, valueGetter: params => {
                let myDate = params?.data?.createdAt != null && params?.data?.createdAt != '' ? new Date(params?.data?.createdAt) : '';
                let dateTimeFormat = (myDate.getMonth() + 1) + '/' + myDate.getDate() + '/' + myDate.getFullYear() + ' ' + formatAMPM(myDate);
                return (dateTimeFormat);
            }

        },
        { headerName: 'Type', field: 'logType', filter: true, resizable: true, flex: 1 },
        {
            headerName: 'Previous Occupant', field: 'preOccupancy', filter: true, resizable: true, flex: 1, valueGetter: params => {
                let preOccupancy = (params?.data?.prevOccupancy != null && params?.data?.prevOccupancy?.btId) ? (params?.data?.prevOccupancy?.btId) : (params?.data?.logType == 'DOOROUT' && params?.data?.outsideCarrierContainer != null && params?.data?.outsideCarrierContainer?.btId) ? (params?.data?.outsideCarrierContainer?.btId) : 'OPEN';
                return preOccupancy;
            }
        },
        {
            headerName: 'User', field: 'user', filter: true, resizable: true, flex: 1, valueGetter: params => {

                let userName = params?.data?.user != null ? (params?.data?.user?.firstName ? params.data.user.firstName : '') + '_' + (params?.data?.user?.lastName ? params.data.user.lastName : '') : '---';
                return userName;
            }
        },
        {
            headerName: 'Current Occupancy', field: 'currentOccupancy', filter: true, resizable: true, flex: 1, valueGetter: params => {
                let currentOccupancy = (params?.data?.currOccupancy != null && params?.data?.currOccupancy?.btId) ? (params?.data?.currOccupancy?.btId) : (params?.data?.logType == 'DOORIN' && params?.data?.outsideCarrierContainer != null && params?.data?.outsideCarrierContainer?.btId) ? (params?.data?.outsideCarrierContainer?.btId) : 'OPEN';
                return currentOccupancy;
            }
        }
    ])


    const cellLogStyle = (params) => {
        return (
            <div onClick={() => {
                setDataForLogs(params.data);
                setIsShowLogClicked(true);
                dispatch({
                    type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_LOG_MANAGEMENT_API_CALL, payload: { value: params.data }
                })
            }}>
                <p style={{
                    width: '100%', height: '70%', backgroundColor: 'rgb(0, 42, 74)', color: 'white', borderRadius: 5, margin: 0, padding: '5px 10px', fontSize: 11
                }}> <strong>{'Show Log'}</strong> </p>
            </div>
        );
    };

    const cellBlankDivisionStyle = (params) => {
        return (
            <div onClick={() => {
            }}>
                {params.data.divisionName && params.data.divisionName != '' ? params.data.divisionName : '--'}
            </div>
        );
    };

    const cellBlankDoorTypeStyle = (params) => {
        return (
            <div>
                {params.data.doorType && params.data.doorType != '' ? params.data.doorType : '--'}
            </div>
        );
    };
    const cellBlankOccupantStyle = (params) => {
        return (
            <div>
                {(params?.data?.btId != null && params?.data?.btId) ? (params?.data?.btId) :
                    (params?.data?.containerBtId != null && params?.data?.containerBtId) ? params?.data?.containerBtId : 'OPEN'}
            </div>
        );
    };


    const showModal = (isShow) => {
        isModalShow(isShow);
    }

    const cellImageRender = (params) => {

        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?

                <div onClick={() => {
                    setCellClickData(params.data);
                    showModal(true);
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/actions.png')} />
                </div>
                : null
        );
    };

    const [columnDefs, setColumnDefs] = useState([])

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }));

    const cellClickedListener = useCallback(event => {
    }, []);

    const paginationNumberFormatter = useCallback((params) => {
        return '[' + params.value.toLocaleString() + ']';
    }, []);

    const onGridReady = useCallback((params) => {
        dispatch({
            type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL
        })

    }, []);

    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.paginationGoToPage(1);
    }, []);


    const importDoor = (file) => {

        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = e => {
            /* Parse data */

            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
            /* Update state */
            if (data && data.length > 0) {
                dispatch({
                    type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.DOOR_BULK_API_CALL, payload: { value: data }
                })
            }
            else {
                alert('Failed to load data');
            }
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
    }

    return (
        <div className='row'>
            {modalShow ? <ModalComponent
                title={cellData != null ? 'Edit Door' : 'Add Door'}
                show={showModal}
                handleClose={showModal}
                doorManagement={true}
                isShow={showModal}
                rowDataDoor={cellData}
                setValue={(value) => {

                    isModalShow(false);

                    if (cellData != null) {
                        setCellClickData(null);
                        dispatch({
                            type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.EDIT_DOORS_MANAGEMENT_API_CALL, payload: { value: value }
                        })
                    }
                    else {

                        dispatch({
                            type: CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_DOORS_MANAGEMENT_API_CALL, payload: { value: value }
                        })

                    }
                }}
            /> : null}


            {isShowLog ?
                <div className="col-12 col-lg-12 col-md-12 col-sm-12 ag-theme-alpine" style={{
                    display: 'flex', flexDirection: 'column', height: '80vh', width: '80vw', justifyContent: 'space-between'
                }}>


                    <div
                        onClick={() => {


                            setCellClickData([]);
                            setIsShowLogClicked(false);
                        }}
                        className="row wrapper col-8 col-md-4 col-sm-6 col-lg-3" style={{
                            marginLeft: 12, marginBottom: 5, height: '4vh', width: 'auto', backgroundColor: 'darkGray', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end'
                        }} >

                        <label style={{ fontSize: '1.1em', color: 'white', textAlign: 'center' }}>{'Show All Doors'}</label>

                    </div>


                    <div className=" col-12 collg-12 col-md-12 col-sm-12 " style={{
                        height: '40vh',

                    }}>
                        <div className="col-12 collg-12 col-md-12 col-sm-12 " style={{
                            display: 'flex', height: '6vh', backgroundColor: '#0dcaf0', border: '2px solid rgba(0, 0, 0, 0.1)', justifyContent: 'center', alignItems: 'center'
                        }}>
                            <label style={{ fontSize: 18, color: 'white' }}>{'Door '}{dataForLogs?.divisionName + ' ' + dataForLogs?.doorType + '_' + dataForLogs?.number}</label>

                        </div>

                        <div className="col-12 collg-12 col-md-12 col-sm-12 " style={{
                            display: 'flex', flexDirection: 'column', height: '24vh', backgroundColor: 'white', border: '2px solid rgba(0, 0, 0, 0.1)',
                        }}>
                            <div className="row col-12 collg-12 col-md-12 col-sm-12 " style={{
                                display: 'flex', height: '12vh', backgroundColor: 'white', borderBottom: '2px solid rgba(0, 0, 0, 0.1)', justifyContent: 'center', alignItems: 'center'
                            }}>
                                <div className=" col-12 col-lg-6 col-md-6 col-sm-12 " style={{
                                    backgroundColor: 'white'
                                }}>
                                    <label style={{ fontSize: 14, color: 'black' }}>{'Division : \n'}{dataForLogs?.divisionName ? dataForLogs.divisionName : '--'}</label>

                                </div>
                                <div className=" col-12 col-lg-6 col-md-6 col-sm-12 " style={{
                                    backgroundColor: 'white'
                                }}>
                                    <label style={{ fontSize: 14, color: 'black' }}>{'Type : \n'}{dataForLogs?.doorType ? dataForLogs.doorType : '--'}</label>

                                </div>
                            </div>

                            <div className="row col-12 collg-12 col-md-12 col-sm-12ƒ " style={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center', height: '12vh', backgroundColor: 'white', borderBottom: '2px solid rgba(0, 0, 0, 0.1)',
                            }}>
                                <div className=" col-12 col-lg-6 col-md-6 col-sm-12 " style={{
                                    backgroundColor: 'white'
                                }}>
                                    <label style={{ fontSize: 14, color: 'black' }}>{'Number : \n'}{dataForLogs?.number ? dataForLogs.number : '--'}</label>

                                </div>
                                <div className=" col-12 col-lg-6 col-md-6 col-sm-12 " style={{
                                    backgroundColor: 'white'
                                }}>
                                    <label style={{ fontSize: 14, color: 'black' }}>{'Current Occupant : \n'}
                                        {dataForLogs?.btId != null && dataForLogs?.btId ? dataForLogs?.btId : (dataForLogs?.containerBtId != null && dataForLogs.containerBtId) ? dataForLogs.containerBtId : 'OPEN'}
                                    </label>

                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 ag-theme-alpine" style={{
                        height: '40vh', width: '80vw', margin: 'auto'
                    }}>


                        <AgGridReact
                            suppressColumnVirtualisation={true}
                            defaultColDef={defaultColDef}
                            animateRows={true}
                            rowData={rowDataDoorLogTemp}
                            rowSelection={'multiple'}
                            rowGroupPanelShow={'always'}
                            pivotPanelShow={'always'}
                            columnDefs={columnDefsLog}
                            paginationNumberFormatter={paginationNumberFormatter}
                        >
                        </AgGridReact>

                    </div>

                </div>
                :
                <div className='col-md-12 col-sm-12 col-12'>


                    <div onClick={() => {
                        setCellClickData(null);

                    }} className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l " style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', margin: '2px 0px 2px 0px' }}>

                        {
                            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                                <DataInput handleFile={importDoor} /> : null
                        }
                        <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                            <div className="input-group">
                                <span className="input-group-text text-body"><i className="fas fa-search" aria-hidden="false"></i></span>
                                <input
                                    aria-label='Search'
                                    autoComplete={'false'}
                                    data-html={true}
                                    data-tip="&amp;#8226; Use atleast 12 characters.<br />
                                    &amp;#8226; Include both lowercase and uppercase characters.<br />
                                    &amp;#8226; Include atleast one number or symbol.<br />
                                    &amp;#8226; Password should not be based on any personal information such as user id, family name, pet, birthday, friends, co-workers, addresses, phone numbers, etc."
                                    aria-describedby="basic-addon2"
                                    type="text" className="form-control" placeholder="Type here..." onChange={(value) => {

                                        let filterData = [];
                                        if (value.target?.value == "") {
                                            filterData = rowDataDoor;
                                            setRowData(filterData);
                                        }
                                        else {

                                            filterData = rowDataDoor?.filter((item) => {
                                                return (item.divisionName?.toLowerCase())?.includes(value.target.value.toLowerCase()) || (item.doorType?.toLowerCase())?.includes(value.target.value.toLowerCase())
                                                    || (item.number?.toString().toLowerCase())?.includes(value.target.value.toLowerCase()) || (item.btId?.toLowerCase())?.includes(value.target.value.toLowerCase())
                                            })
                                            setRowData(filterData);
                                        }
                                    }
                                    }></input>

                            </div>
                        </div>

                        {
                            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                                <img
                                    onClick={() => {
                                        isModalShow(true);
                                        setCellClickData(null);
                                    }}
                                    src={require('./../assets/Dashboard/plus.png')} style={{ display: 'flex' }}></img>
                                : null
                        }
                        {isShowLog ||
                            (loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN))) ?

                            <p
                                style={{ fontSize: 14, textAlign: 'center', backgroundColor: 'lightBlue', borderRadius: 8, marginLeft: 14, padding: 6, margin: 0 }}
                                onClick={() => {
                                    let exportData = [];

                                    for (let i = 0; i < rowData?.length; i++) {
                                        let currentOccupancy = (rowData[i]?.btId != null && rowData[i]?.btId) ? (rowData[i]?.btId) : (rowData[i]?.containerBtId != null && rowData[i]?.containerBtId) ? rowData[i]?.containerBtId : 'OPEN';
                                        let data = { 'Division': rowData[i]?.divisionName, 'Door Type': rowData[i].doorType, 'Number': rowData[i]?.number, 'Current Occupancy': currentOccupancy };
                                        exportData[i] = data;
                                    }
                                    exportFile('DoorReport', exportData, ['Division', 'Door Type', 'Number', 'Current Occupancy'])
                                }}>
                                EXPORT
                            </p>
                            : null
                        }
                    </div>



                    <div className="col-md-12 col-sm-12 row-10 ag-theme-alpine" style={{
                        height: '80vh', width: '80vw', margin: 'auto'
                    }}>

                        <AgGridReact
                            ref={gridRef}
                            suppressColumnVirtualisation={true}
                            defaultColDef={defaultColDef}
                            animateRows={true}
                            onCellClicked={cellClickedListener}
                            rowData={rowData}
                            pagination={false}
                            paginationAutoPageSize={false}
                            paginationPageSize={10}
                            paginateChildRows={false}
                            enableRangeSelection={false}
                            suppressRowClickSelection={false}
                            groupSelectsChildren={false}
                            rowSelection={'multiple'}
                            rowGroupPanelShow={'always'}
                            pivotPanelShow={'always'}
                            columnDefs={columnDefs}
                            paginationNumberFormatter={paginationNumberFormatter}
                            onGridReady={onGridReady}
                            onFirstDataRendered={onFirstDataRendered}
                        >
                        </AgGridReact>

                    </div>
                </div>
            }
        </div>

    );
};
export default DoorsComp;